import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-end mb-4 mt-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-xl" }, null, -1)
const _hoisted_3 = { class: "table-wrapper" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "icon-tooltip" }
const _hoisted_9 = { class: "tooltiptext" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "icon-tooltip" }
const _hoisted_12 = { class: "tooltiptext" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "icon-tooltip" }
const _hoisted_15 = { class: "tooltiptext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        class: "btn-outline-blue w-58 h-12",
        onClick: _ctx.goToRegisterWorkingStyleMaster
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.t('newRegistration')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Table, {
        headers: _ctx.attendanceDataHeaders,
        data: _ctx.workingStyleMasterData,
        showPagination: true,
        "record-total": _ctx.pagination.total,
        "items-per-pages": _ctx.pagination.per_page,
        currentPage: _ctx.apiWorkingStyleMasterListParams.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiWorkingStyleMasterListParams.page = $event)),
        onOnChangePage: _ctx.onChangePage
      }, {
        working_style_code: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_4, _toDisplayString(item.working_style_code), 1)
        ]),
        working_style_name: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_5, _toDisplayString(item.working_style_name), 1)
        ]),
        working_style_apply_date: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_6, _toDisplayString(_ctx.displayDate(item.working_style_apply_date)), 1)
        ]),
        editAction: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t('actionEdit')), 1),
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.updateWorkingStyleMaster(item)),
                class: "cp-icon-edit-square text-2xl hover:text-blue-600 cursor-pointer text-gray-333"
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        removeAction: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t('actionDelete')), 1),
              _createVNode("span", {
                class: "cp-icon-trash text-2xl hover:text-blue-600 cursor-pointer",
                onClick: ($event: any) => (_ctx.removeItem(item))
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        copyAction: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t('actionCopy')), 1),
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.copyWorkingStyleMaster(item)),
                class: "cp-icon-copy text-2xl hover:text-blue-600 cursor-pointer"
              }, null, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["headers", "data", "record-total", "items-per-pages", "currentPage", "onOnChangePage"])
    ])
  ], 64))
}